module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3cbe5be8dba7df255a9049fa3db394d4.gif";